import type { CountryCode } from '../constants/countries';
import { COUNTRIES } from '../constants/countries';

export function isCountryCode(code: string): code is CountryCode {
  return COUNTRIES.some((c) => c.value === code);
}
